import { useSelector } from 'react-redux';
import { selectAllFeatureFlags } from 'redux/client-config/client-config.selectors';
import { FeatureFlag } from 'util/client-configuration';

export const useIsFeatureFlagEnabled = (featureFlag: FeatureFlag) => {
  const allFeatureFlags = useSelector(selectAllFeatureFlags);
  return allFeatureFlags[featureFlag];
};
